import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from '@angular/common/http';
import { TokenStorageService } from '../services/token-storage.service';
import { TokenService } from '../services/token.service';
import { RefreshTokenRequest } from '../auth/auth.type';
import { Observable, of, switchMap, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';

const BEARER_PREFIX = 'Bearer ';

@Injectable({
  providedIn: 'root'
})
export class AuthHeaderInterceptor implements HttpInterceptor {

  constructor(
    private _authService: AuthService,
    private _tokenStorageService: TokenStorageService,
    private _tokenService: TokenService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) : Observable<HttpEvent<any>> {
    
    const accessToken = this._tokenStorageService.getAccessToken()
    const refreshToken = this._tokenStorageService.getRefreshToken()

    // endpoint from login page
    if(req.url.includes('tokens')) {
      return next.handle(req)
    }

    if(accessToken === null || refreshToken === null) {
      this._tokenService.removeTokensAndOpenSessionDialog('session_expired') 
      throw accessToken ? throwError('Access token not available') : throwError('Refresh token not available')
    }

    const isAccessTokenExpired: boolean | null = this._tokenService.checkTokenExpiration()
    // if access token is not expired
    // if end point is refresh token ignore calling the api - hence to looping the interceptor
    if(!isAccessTokenExpired || req.url.includes('refresh-token') ) {      
      // add access to token to req header
      req = req.clone({
        url:  req.url,
        setHeaders: {
          Authorization: BEARER_PREFIX + accessToken
        }
      });
      return next.handle(req)
    }

    const isRefreshTokenExpired: boolean = this._tokenService.checkRefreshTokenExpiration()
    // if refresh token expired
    if(isRefreshTokenExpired) {
      this._tokenService.removeTokensAndOpenSessionDialog('session_expired') 
      throw throwError('Refresh Token Expired')
    }

    // ************ Refresh Token Not Expired And Access Token Expired *****************

    const refreshTokenRequest: RefreshTokenRequest = {
      preToken: accessToken,
      refreshToken: refreshToken
    }

    // constructing a pipe in order to manage async methods
    return of(refreshTokenRequest).pipe(
      switchMap((refreshTokenRequest: RefreshTokenRequest) => {
        return this._authService.refreshTokenLocalStorageUpdate(refreshTokenRequest)
      }),
      switchMap(() => {
        const newAccessToken = this._tokenStorageService.getAccessToken()
        // add new access token to req header
        req = req.clone({
          url:  req.url,
          setHeaders: {
            Authorization: BEARER_PREFIX + newAccessToken
          }
        });
        return next.handle(req)
      })
    );
  }
}